import Task from "../../../../lib/html5-software-library/src/ranj/util/executor/Task";
import NavigateEvent from "../../app/navigation/NavigateEvent";
import SkinFactory from "../../app/ui/SkinFactory";
import SkinKeys from "../../app/ui/SkinKeys";

export default class ShowPreloadScreenTask extends Task {
    constructor(dispatcher) {
        super();

        this.execute = function(callback, progressCallback) {
            const preloadScreen = SkinFactory.getSkin(SkinKeys.PRELOAD_SCREEN_SKIN);
            var commandEvent = new NavigateEvent(NavigateEvent.GOTO_SCREEN_REQUEST, null, preloadScreen);
            dispatcher.dispatch(commandEvent.type, { data: commandEvent });
            callback(this);
        }
    }
}
